// A single User account can be both a passenger (books bus tickets) and
// transport-provider staff (same login identity, different portal) — the
// backend's Notification.userId scoping alone can't tell those two roles
// apart, so one role's history leaks into the other's bell/popup. These
// lists are how each portal's NotificationBell / notification popup tells
// the backend which types are actually relevant to it (see
// backend/src/controllers/notificationController.js's optional `types`
// query param).
//
// Keep in sync with the type strings passed to createNotification(...)
// across backend/src/controllers/*.js.
export const PASSENGER_NOTIFICATION_TYPES = [
  'new_booking', 'ticket_issued', 'payment_rejected',
  'new_parcel', 'parcel_payment_submitted',
  'transport_quote_received', 'transport_vehicle_assigned',
  'transport_order_picked_up', 'transport_order_in_transit', 'transport_order_delivered',
  'ride_offer_received', 'ride_driver_en_route', 'ride_driver_arrived', 'ride_in_progress', 'ride_completed',
  'trip_cancelled', 'departure_reminder', 'no_show_alert',
];

export const PROVIDER_NOTIFICATION_TYPES = [
  'ride_request_new', 'cargo_request_new', 'ride_offer_accepted', 'transport_quote_accepted',
];
